module.exports = __webpack_public_path__ + "static/media/PC_Workshop_API_GATEWAY.96eb2794.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/APIGATEWAY/PC_Workshop_API_GATEWAY.png
// module id = 246
// module chunks = 0